const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const createShortLink = async (url) => {
  const response = await fetch(`${API_URL}/api/short-links`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Não foi possível encurtar agora.')
  return data.id
}

export const resolveShortLink = async (id) => {
  const response = await fetch(`${API_URL}/api/short-links/${id}`)
  if (!response.ok) return null
  return response.json()
}

export const fetchShortLinkStats = async (id) => {
  const response = await fetch(`${API_URL}/api/short-links/${id}/stats`)
  if (!response.ok) return null
  return response.json()
}
